import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    ViewEncapsulation
} from '@angular/core';
import { SideMenuChildComponent } from '../../../navigation/side-menu/components/side-menu-child/side-menu-child.component';
import { AuthorBlockComponent } from '../author-block/author-block.component';
import { Author } from './models/authors.type';
import { Contributor } from './models/contributors.type';

@Component({
    selector: 'nw-contributors-selection-block',
    imports: [SideMenuChildComponent],
    templateUrl: './contributors-selection-block.component.html',
    styleUrl: './contributors-selection-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class ContributorsSelectionBlockComponent implements OnChanges {
    @Input() contributors!: Contributor[];
    @Input() activeid: number = -1;

    public authors!: Author<AuthorBlockComponent>[];
    public baseUrl!: string;
    public allActive: boolean = true;

    public ngOnChanges(): void {
        const BASE_URL: URL = new URL(window.location.href);
        BASE_URL.searchParams.delete('authors');
        BASE_URL.searchParams.delete('page');

        this.baseUrl = BASE_URL.toString();

        this.allActive = -1 === Number.parseInt(`${this.activeid}`);

        this.authors = this.contributors?.map((contributor: Contributor) => {
            const BASE_URL: URL = new URL(window.location.href);
            BASE_URL.searchParams.delete('authors');
            BASE_URL.searchParams.delete('page');
            BASE_URL.searchParams.append('authors', `${contributor.id}`);

            return {
                active:
                    Number.parseInt(`${contributor.id}`) ===
                    Number.parseInt(`${this.activeid}`),
                id: contributor.id,
                url: `${BASE_URL.toString()}`,
                dynamic: {
                    component: AuthorBlockComponent,
                    inputs: {
                        name: contributor.name,
                        jobtitle: contributor.jobTitle,
                        pictureurl: contributor.avatar,
                        picturealt: `${contributor.name} picture`
                    }
                }
            };
        });
    }
}
